import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getPaymentRedirectUrl,
  cancelTrialSubscription,
  completeSubscriptionCancellation,
} from "../utils/schoolSubscription";

export function useTrialExpiredModal(signupData) {
  const navigate = useNavigate();
  const [showTrialExpiredModal, setShowTrialExpiredModal] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;

  const handleTrialRenew = useCallback(() => {
    const paymentUrl = getPaymentRedirectUrl(signupData);
    if (!paymentUrl) {
      toast.error("Payment page URL is not configured. Please contact your administrator.");
      return;
    }
    window.location.href = paymentUrl;
  }, [signupData]);

  const handleTrialCancel = useCallback(async () => {
    setCancelLoading(true);
    try {
      await cancelTrialSubscription(baseURL, signupData);
      completeSubscriptionCancellation(signupData);
      setShowTrialExpiredModal(false);
      toast.success("Your subscription has been cancelled.");
      navigate("/landingpage", { replace: true });
    } catch (error) {
      toast.error(
        error.message || "Failed to cancel subscription. Please try again."
      );
    } finally {
      setCancelLoading(false);
    }
  }, [baseURL, signupData, navigate]);

  return {
    showTrialExpiredModal,
    setShowTrialExpiredModal,
    handleTrialRenew,
    handleTrialCancel,
    cancelLoading,
  };
}
